import React from 'react';
import { Container, Row, Col, Card, CardTitle, CardText, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css';

const Services = () => {
    return (
        <div className='div-padd'>
        <div className="hero-section">
          <Container>
            
                <br/>
                <h1 className="display-4">Brave Fox Services</h1>
                <br></br>
                <br/>
                <p className="lead"><h2>Key Services we deliver:</h2>
                <br/>
                
                <li>
                Delivering Turnkey IT projects
  </li>
  <li>
  Delivering Consulting Assignments in
  <ul>
  <li>
  Bid Management
  </li>
  <li>
  Proposal and Maketing Management
  </li>
  <li>
  Quality & Control

  </li>
  <li>
  Project Management
  </li>
  <li>
  ERT reviews

  </li>
  <li>
  Reviews and recommendation of projects current state and suggested state to be at
  </li>
  </ul>
  </li>
  <li>
  Staff Aumentation of resources
  </li>
  <li>
  Value Added Reselling and Implementation of Software Products
  </li>
  <li>
  Resource Process Outsourcing
  </li>
  <li>
  Business Process Outsourcing
  </li>

     
                </p>
              <p/>



    
                
              
          </Container>
        </div>


        <div className="hero-section">
          <Container>
            
                <br/>
                
                <br></br>
                <br/>
                <p className="lead"><h2>Key technologies we outperform on:</h2>
                <br/>
                
                <li>
                JDA suit of Technologies
  </li>
  <li>
  Oracle Cloud and Apps Tech
  </li>
  <li>
  Microsoft Azure
  </li>
  <li>
  Microsoft.NET
  </li>
  <li>
  Service Oriented Architecture
  </li>
  <li>
  Silverlight
  </li>
  <li>
  Databases - Oracle and MS SQL Server

  </li>
  <li>
  BI - SQL Reporting Services and Business scorecard manager
  </li>
  
  
  <li>
  Microsoft Office SharePoint Server (MOSS)
  </li>
  <li>
  Biztalk

  </li>
  <li>
  Microsoft Dynamics
  </li>
  <li>
  Oracle BI
  </li>
  <li>
  Peoplesoft

  </li>
  <li>
  Java/J2EE
  </li>
  <li>
  Other Microsoft and Oracle Range of Tech Stack
  </li>

     
                </p>
              <p/>



    
                
              
          </Container>
        </div>


        <div className="hero-section">
          <Container>
            
                <br/>
                
                <br></br>
                <br/>
                <p className="lead"><h2>Brave Fox key capabilities:</h2>
                <br/>
                
                <p>
                A detailed not on our offerings and what our clients leverage us in the Microsoft Tech Stack is listed in the Microsoft Capability Section. We deliver similar solutions in Oracle and other tech stacks.
                </p>

     
                </p>
              <p/>



    
                
              
          </Container>
        </div>


        <div>
            <br/>
            <br/>
        <p className="lead"><h2>Customer Speaks:</h2></p>
        <Row>
          
  <Col sm="5">
    <Card body className='padd'>
      <CardTitle tag="h5">
      Senior Management Staff Leading IT Firm
      </CardTitle>
      <CardText>
      Brave Fox has an exceptional ability to turn stressful situations to normal by providing quality service.
     
      </CardText>
      <br/>
      
    </Card>
  </Col>
  
  <Col sm="5">
    <Card body className='padd'>
      <CardTitle tag="h5">
      CTO, Leading Retail firm
      </CardTitle>
      <CardText>
      I approached Brave Fox while project was in red, their approach to understand issues from managerial level till CX was outstanding! They were able to convert the project from red to gree in no time. Hats off!
      </CardText>
      
    </Card>
  </Col>
</Row>
<br/>
<br/>
        </div>

        </div>
    );
}
export default Services;